/** @jsxImportSource @emotion/react */
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';

const StyledSideToSideTable = styled(Table)(() => ({
  minWidth: '100%',
}))

export default StyledSideToSideTable;